import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {from, of} from 'rxjs';
import {catchError, map, mergeMap, switchMap, toArray} from 'rxjs/operators';
import {FeatureFlagKey} from '../models/feature-flag-keys.model';
import {FeatureFlagService} from '../services/feature-flag.service';
import * as FeatureFlagActions from './feature-flag.actions';

@Injectable()
export class FeatureFlagEffects {
  private readonly actions$ = inject(Actions);
  private readonly featureFlagService = inject(FeatureFlagService);


  loadFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagActions.loadFeatureFlags),
      switchMap(() => {
        const keys = environment.featureFlagKeys ?? {};
        return from(Object.values(keys) as FeatureFlagKey[]).pipe(
          mergeMap(flag => this.featureFlagService.fetchFeatureFlags(flag.name, flag.type)),
          toArray(),
          map(flagsArray => FeatureFlagActions.loadFeatureFlagsSuccess({flags: flagsArray})),
          catchError(error => of(FeatureFlagActions.loadFeatureFlagsFailure({error})))
        );
      })
    )
  );
}
